<template>
    <div class="np-tree-menu">
        <router-link :to="url" :title="label" relative tag="div" class="label-wrapper">
            <div :style="indent" :class="labelClasses">
                <i v-if="nodes" class="marginBottom5 fa" :class="iconClasses" @click="toggleChildren" ></i>
                <a href="url"><span>{{ label }}</span></a>
            </div>
        </router-link>
        <np-tree-menu
                v-show="showChildren"
                v-for="node in nodes"
                :nodes="node.nodes"
                :metadata="node.metadata"
                :key="`node_${uniqueRef()}`"
                :depth="depth + 1"
        >
        </np-tree-menu>
    </div>
</template>
<script>
    import componentEventBus from './event_bus'
    export default {
        props: ['metadata', 'nodes', 'depth', 'currentRoute'],
        name: 'np-tree-menu',
        data: function () {
            return {
                showChildren: false
            }
        },
        mounted: function () {
            this.showChildren = this.urlMatch;
        },
        computed: {
            indent() {
                return {transform: `translate(${((this.depth + 1) * 10) + (!!this.nodes === false ? 5 : 0)}px)`}
            },
            labelClasses() {
                return { 'has-children': this.nodes }
            },
            urlMatch () {
                let vm = this;
                return  !!this.nodes && this.nodes.some(obj => !!vm.currentRoute && vm.currentRoute.includes(obj.metadata.url));
            },
            iconClasses() {
                return {
                    'fa-plus-square-o': !this.showChildren,
                    'fa-minus-square-o': this.showChildren
                }
            },
            label() {
                return !!this.metadata && !!this.metadata.label ? this.metadata.label : ''

            },
            url() {
                return !!this.metadata && !!this.metadata.url ? this.metadata.url : ''
            },
        },
        watch: {
            urlMatch: function (val, oldVal) {
                if (!this.showChildren && val) {
                    this.showChildren = true;
                }
            }
        },
        methods: {
            uniqueRef() {
                let rand = String(Math.random());
                rand = rand.split('.')[1];
                return rand;
            },
            toggleChildren() {
                this.showChildren = !this.showChildren;
                componentEventBus.$emit('treechildclick',this.showChildren)
            },
            handleChildClick($event, node) {
            }
        }
    }
</script>
<style scoped>
    .np-tree-menu {
        overflow: hidden;
    }
    .np-tree-menu i {
        cursor: context-menu;
    }
    .np-tree-menu span {
        cursor: pointer;
        font-size: 13px;
    }
    .np-tree-menu .label-wrapper {
        padding-bottom: 10px;
        padding-top: 7px;
        border-bottom: 1px solid #ccc;
        height: 35px;
        position: relative;
    }
    .np-tree-menu .has-children {
        cursor: pointer;
    }
    .np-tree-menu .label-wrapper.router-link-active:after{
        content: '';
        display: block;
        width: 23px;
        height: 23px;
        position: absolute;
        top: 4px;
        z-index: 1;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        transform: rotate(45deg);
        -webkit-transition: all 0.6s ease-in-out;
        -moz-transition: all 0.6s ease-in-out;
        transition: all 0.6s ease-in-out;
        right: -15px;
        background-color: #004165;
        color: #ffffff;
    }

</style>